<template>
	<div class="reset">
		<div class="reset-sub-cont">
			<div class="header5">Hi! There</div>
			<div class="header2">Reset your password</div>
			<br />
			<form class="reset-form-container" action="#">
				<InputBox placeHolder="Please Enter New Password" type="password" v-model="newPassword" />
				<InputBox placeHolder="Confrim Password" type="password" v-model="confirmPassword" />
				<div class="mid-sec">
					<Button title="Submit" :onClick="submit" />
				</div>
			</form>
			<div v-if="ifError" class="log-cont">
				<div class="paragraph back-reset">Back to <span @click="goForgot">Resend Forgot Password Email!</span></div>
			</div>
		</div>
	</div>
</template>

<script>
// import { Prop } from "vue-property-decorator";
import InputBox from "@/components/ui/InputBox.vue";
import Button from "@/components/ui/Button.vue";
import { AUTH_RESET } from "../store/constants";

import localData from "@/store/utils/localdata";
export default {
	name: "reset",
	title: "Reset",
	components: {
		InputBox,
		Button,
	},
	data() {
		return {
			newPassword: "",
			confirmPassword: "",
			ifError: false,
		};
	},
	mounted() {
		this.ifError = false;
	},
	methods: {
		async submit() {
			const data = {
				token: this.$route.query.t,
				newPassword: this.newPassword,
				confirmPassword: this.confirmPassword,
			};
			try {
				const result = await this.$store.dispatch(AUTH_RESET, data);
				if (result && result.isvalid) this.changedPassword();
			} catch (ex) {
				console.log("error", ex);
				this.$toast.open({
					message: ex.msg,
					position: "top",
					type: "error",
				});
				this.ifError = true;
			}
		},
		setSentEmail() {
			this.sentEmail = true;
		},
		changedPassword() {
			this.$toast.open({
				message: "Password reset successful",
				position: "top",
				type: "success",
			});
			setTimeout(() => {
				this.$router.push({ name: "Login" });
			}, 2000);
		},
		goLogin() {
			this.$router.push({ name: "Login" });
		},
		goForgot() {
			this.$router.push({ name: "Forgot" });
		},
	},
};
</script>

<style scoped lang="scss">
.reset {
	background: var(--dark-blue);
	height: 100%;
	padding-bottom: 5vw;
	width: 100%;
	.reset-sub-cont {
		padding: 9vw 5vw;
		.header5 {
			color: var(--accent);
			font-size: 18px;
			margin-bottom: 20px;
		}
		.header2 {
			color: var(--white);
			font-size: 51px;
			line-height: 51px;
		}
		.paragraph {
			width: 500px;
			text-align: center;
			margin: auto;
			color: var(--white);
			opacity: 0.5;
			margin-top: 20px;
		}
		.reset-form-container {
			max-width: 500px;
			margin: 0 auto;
			margin-top: 2vw;
			.mid-sec {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				margin-top: 11px;
				align-items: center;
				.forgot {
					text-align: left;
					margin-bottom: unset;
					color: var(--white);
					opacity: 0.5;
				}
				.forgot:hover {
					color: var(--accent);
					cursor: pointer;
				}
			}
		}
		.back-reset {
			color: white;
			margin-top: 2px;
			width: 500px;
			text-align: left;
			margin: auto;
			opacity: 1;
			span {
				font-style: normal;
				font-weight: 500;
				font-size: 18px;
				line-height: 27px;
				text-align: center;
				cursor: pointer;
				color: rgba(80, 205, 243, 1);
			}
			& :hover {
				color: var(--primary);
			}
		}
		.log-cont {
			margin-top: 60px;
			margin-bottom: 70px;
		}
		.reset-register-cont {
			max-width: 500px;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			margin: 0 auto;
			margin-top: 65px;
			margin-bottom: 150px;
			.header5.register {
				padding-bottom: unset;
				margin-bottom: unset;
				color: var(--white);
				font-size: 18px;
			}
		}
	}
}
@media screen and (max-width: 414px) {
	.reset .reset-sub-cont {
		.header5 {
			padding-bottom: 4vw;
			font-size: 14px;
			margin-bottom: unset;
		}
		.header2 {
			padding-bottom: 4vw;
			font-size: 36px;
			line-height: 36px;
		}
		.paragraph {
			font-size: 16px;
			line-height: 32px;
			width: unset;
			margin: unset;
			margin-top: 12px;
		}
		.container {
			padding-top: 15vw;
			margin-top: unset;
			.forgot {
				font-weight: normal;
				font-size: 14px;
				line-height: 21px;
				color: var(--white);
				opacity: 0.5;
				margin: 15px 0;
			}
		}
		.reset-register-cont {
			.header5.register {
				font-size: 14px;
			}
			.outline.button {
				border-radius: 30px;
				color: var(--white);
				border-color: var(--white);
			}
		}
	}
}
</style>
